export default {
  brandColor1: '#46bbbf',
  complimentaryColor1: '#ffffff',
  brandColor2: '#46bbbf',
  complimentaryColor2: '#ffffff',
};
